import { IApiClient } from '@base/features/api/model/apiClient';
import { IHelpService, IssueInfo } from './interfaces';
import API_PATHS from '@base/features/api/constants/apiPaths';
class HelpService implements IHelpService {
  constructor(private gameId: number, private apiClient: IApiClient) {}

  async getIssueInfo(): Promise<IssueInfo> {
    const res = await this.apiClient.get(
      {
        do: 'contact_us',
        json: 1,
      },
      API_PATHS.contactus2
    );

    const data = await res.json();
    if (data.code !== 0) {
      throw new Error(data.descr || 'Unknown error');
    }
    return data;
  }

  async contactUsWithParams(
    key: string,
    name: string,
    email: string,
    category: string,
    Your_Comments: string,
    issue?: string,
    log?: any
  ): Promise<any> {
    const res = await this.apiClient.get(
      {
        do: 'contact_us',
        gameid: this.gameId,
        key: key,
        name: name,
        email: email,
        category: category,
        Your_Comments: Your_Comments,
        issue: issue,
        log: log,
        json: 1,
      },
      API_PATHS.contactus2
    );
    return await res.json();
  }
}

export default HelpService;
